import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { addErrorMessageBody, toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PREPARE_ACCOUNT_CONTINUE_CLICKED, PREPARE_ACCOUNT_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYOUT_COUNTRY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { GA } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_PROFILE_RESTRICTED_MIGRATION_CONFIRM_ACTION, URL_CLOUD } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const GAMigrationModal = ({ country, ...props }) => {
    const { continueButton, notNowButton, migrationGlobalAccountTitle, migrationGlobalAccountSubTitle } = usePageMessages();
    const defaultDuration = 10000;

    useEffect(() => {
        amplitude.getInstance().logEvent(PREPARE_ACCOUNT_SCREEN_SHOWN, {
            [PAYOUT_COUNTRY]: GA,
        });
    }, []);

    const sendRequestToOptIn = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        amplitude.getInstance().logEvent(PREPARE_ACCOUNT_CONTINUE_CLICKED, {
            [PAYOUT_COUNTRY]: GA,
        });
        props.popupFullwidthRef.current?.close();
        apiFetchData(AUTH_PROFILE_RESTRICTED_MIGRATION_CONFIRM_ACTION, { id: { name: 'id', value: country?.id } })
            .then((json) => {
                if (json?.extra) {
                    props.addExtras(json.extra);
                }
                if (json?.extra?.error && json?.message) {
                    props.addErrorMessageBody(json.message);
                }
                if (json?.extra?.showSuccessOptInInfo && json?.messages) {
                    props.modalRef.current?.open(
                        <ModalComponent isVerticalCentered canCloseModal={false} modalRef={props.modalRef}>
                            <InfoPage
                                insideModalComponent
                                iconName="clock-80"
                                iconColor="primary"
                                headerText={
                                    <>
                                        {json.messages?.successOptInBetaTitle}
                                        <br />
                                        <span className="color-GT">{json.messages?.successOptInBetaTitleViolet}</span>
                                    </>
                                }
                                secondaryText={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={json.messages?.successOptInBetaMessage} />}
                            />
                        </ModalComponent>,
                    );
                }
                props.toggleSpinner(false);
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const closeStories = () => {
        props.popupFullwidthRef.current?.close();
    };

    const getSteps = () => {
        return [
            <StoryLayout
                key="migration-only"
                topButtonCaption={notNowButton}
                onTopButtonClick={closeStories}
                title={migrationGlobalAccountTitle}
                subtitle={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={migrationGlobalAccountSubTitle} />}
                contentPosition="top"
                bottomButtonCaption={continueButton}
                onBottomButtonClick={sendRequestToOptIn}
                variant="secondary_base"
                imgA={`${URL_CLOUD}/images/web/beta-promo-stories/beta-promo-stories-a.webp`}
                imgA2x={`${URL_CLOUD}/images/web/beta-promo-stories/beta-promo-stories-a@2x.webp`}
                imgB={`${URL_CLOUD}/images/web/beta-promo-stories/beta-promo-stories-b.webp`}
                imgB2x={`${URL_CLOUD}/images/web/beta-promo-stories/beta-promo-stories-b@2x.webp`}
            />,
        ];
    };

    return <Stories steps={getSteps()} isInverted infinityLoop duration={defaultDuration} />;
};
export default connect(null, { addErrorMessageBody, addExtras, toggleSpinner })(GAMigrationModal);
